import { API } from 'aws-amplify';

import { Itinerary } from '../../types/Itinerary';

export const getItineraryTemplates = (
  citySlug: string
): Promise<Itinerary[]> => {
  return API.get('party', `/cities/${citySlug}/itineraryTemplates`, {});
};

export const createItineraryTemplates = (
  citySlug: string,
  itinerary: Itinerary
): Promise<Itinerary> => {
  return API.post('party', `/cities/${citySlug}/itineraryTemplates`, {
    body: itinerary,
  });
};

export const updateItineraryTemplates = (
  citySlug: string,
  id: string,
  itinerary: Partial<Itinerary>
): Promise<Itinerary> => {
  return API.patch('party', `/cities/${citySlug}/itineraryTemplates/${id}`, {
    body: {
      ...itinerary,
    },
  });
};

export const deleteItineraryTemplates = (
  citySlug: string,
  id: string
): Promise<void> => {
  return API.del('party', `/cities/${citySlug}/itineraryTemplates/${id}`, {});
};
